<template>
    <div class="modal fade" id="jsonFormatterModal" role="dialog" aria-labelledby="jsonFormatterModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="jsonFormatterModalLabel">{{$t(titleKey)}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <vue-json-pretty :path="'res'"
                                     :data="jsonData">
                    </vue-json-pretty>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueJsonPretty from 'vue-json-pretty'

    export default {
        components: {
            VueJsonPretty
        },
        props: {
            value: [String, Object],
            show: {
                type: Boolean,
                default: false
            },
            titleKey: String
        },
        data() {
            return {
                showDetails: false,
                jsonData: '',
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.jsonData = '';
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.jsonData = this.value;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
